// Centraliza os caminhos da API do domínio 'mit-apuracao'
const API_PREFIX = 'mit-serpro'
export default {
  paged: (page, pageSize) => `${API_PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`,
  consultarApuracaoEmpresa: `${API_PREFIX}/consultar-apuracao-mit`,
  consultarApuracaoMesAno: `${API_PREFIX}/consultar-apuracao-mit`,
  debitosValores: (pagina, tamanhoPagina) => `${API_PREFIX}/debitos/valores?pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`,
  debitosEncerramento: (pagina, tamanhoPagina) => `${API_PREFIX}/debitos/encerramento?pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`,
  suspensoes: (pagina, tamanhoPagina) => `${API_PREFIX}/suspensoes?pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`,
}
